module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f36d5cbad056bc5dae54130fdef5658a.png";